import React from 'react';

import AttachmentIcon from '@mui/icons-material/Attachment';
import { useTheme } from '@mui/material/styles';
import {
    List,
    ListItem,
    ListItemButton,
    ListItemText,
} from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { TEMPLATE_TYPES } from 'common/constants';

import { getDocumentItemSx } from '../helpers';

import SideMenuCard from './SideMenuCard';

const AttachmentsCard = ({
    documents,
    handleClickDocumentItem,
    isDisabled,
    selectedDocumentId,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    if (isEmpty(documents)) return null;
    return (
        <SideMenuCard
            icon={<AttachmentIcon sx={{ color: 'primary.main' }} />}
            title={t('Attachment', { count: 2 })}
        >
            <List disablePadding>
                {documents.map((document) => (
                    <ListItem
                        disabled={
                            isDisabled || document.id === selectedDocumentId
                        }
                        disablePadding
                        key={`system-document-${document.id}`}
                        selected={document.id === selectedDocumentId}
                        sx={getDocumentItemSx(theme)}
                    >
                        <ListItemButton
                            onClick={() => {
                                if (isDisabled) return;
                                handleClickDocumentItem({
                                    archive: document.file,
                                    id: document.id,
                                    name: document.name,
                                    type: TEMPLATE_TYPES.PDF_TYPE,
                                });
                            }}
                            sx={{ borderRadius: '8px' }}
                        >
                            <ListItemText primary={document.name} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </SideMenuCard>
    );
};

AttachmentsCard.propTypes = {
    documents: PropTypes.array,
    handleClickDocumentItem: PropTypes.func,
    isDisabled: PropTypes.bool,
    selectedDocumentId: PropTypes.string,
};

export default AttachmentsCard;
